module.exports = __webpack_public_path__ + "img/result-detail-sacrifice-outleft02.2181722a.svg";